import helpers from '@/router/helpers';
import UserRoles from '@/constants/user/roles';

export default {
    path: '/mail/pickup',
    meta: {
        title: 'PickUp',
        documentTitle: 'Mail PickUp',
        requiresAuth: true,
        mdiIcon: 'arrow-up-bold-circle',
        allowedRoles: [
            UserRoles.SUPER_ADMIN,
            UserRoles.MAIL_OPERATOR,
        ],
    },
    component: helpers.getRouterView(),
    children: [
        {
            path: '',
            name: 'MailPickup',
            meta: {
                title: 'Pickup',
                documentTitle: 'Mail Pickup',
                shouldPersistBetweenLogins: true,
                allowedRoles: [
                    UserRoles.SUPER_ADMIN,
                    UserRoles.MAIL_OPERATOR,
                ],
            },
            component: () => import( /* webpackChunkName: "MailPickUp" */ '@/views/mail/PickUp' ),
        },
        {
            path: 'detail',
            redirect: '/mail/pickup',
            meta: {
                title: 'Pickup Detail',
                documentTitle: 'Pickup Detail',
            },
        },
        {
            path: 'detail/:id',
            meta: {
                title: 'Pickup Detail',
                documentTitle: 'Pickup Detail',
            },
            component: helpers.getRouterView(),
            children: [
                {
                    path: '',
                    name: 'MailPickupDetail',
                    meta: {
                        title: 'Pickup Detail',
                        documentTitle: 'Pickup Detail',
                    },
                    component: () => import( /* webpackChunkName: "MailPickupDetail" */ '@/views/mail/pickup/PickupDetail' ),
                },
            ],
        },
    ],
};
